"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onQualityChanged;
function onQualityChanged(event) {
  var currentRendition = this._activeQuality;
  var currentLevel = this.rawPlayer.getCurrentQuality();
  var newRendition = this.rawPlayer.getQualityLevels()[currentLevel];
  var bitrateEvent = {
    prevBitrate: currentRendition.bitrate,
    prevHeight: currentRendition.height,
    prevWidth: currentRendition.width,
    newBitrate: newRendition.bitrate,
    newHeight: newRendition.height,
    newWidth: newRendition.width,
    prevDuration: Number((performance.now() - this.logger.times.DurationBitrate).toFixed(2))
  };
  if (bitrateEvent.prevBitrate && bitrateEvent.prevBitrate !== bitrateEvent.newBitrate) {
    this.logger.logQuality('BitrateChanged', bitrateEvent);
  }
  this.logger.times.DurationBitrate = performance.now();
  this._activeQuality = newRendition;
  this.emit('qualitychanged', event);
}